module.exports = __webpack_public_path__ + "static/brandvoice-83ad3191ac24865a18da00a198931e5a.png";